"use strict";
var $ = require("../internals/export");
var uncurryThis = require("../internals/function-uncurry-this");
var aCallable = require("../internals/a-callable");
var toIndexedObject = require("../internals/to-indexed-object");
var arrayFromConstructorAndList = require("../internals/array-from-constructor-and-list");
var getBuiltInPrototypeMethod = require("../internals/get-built-in-prototype-method");
var addToUnscopables = require("../internals/add-to-unscopables");
var $Array = Array;
var sort = uncurryThis(getBuiltInPrototypeMethod("Array", "sort"));
$({ target: "Array", proto: true }, {
  toSorted: function toSorted(compareFn) {
    if (compareFn !== void 0) aCallable(compareFn);
    var O = toIndexedObject(this);
    var A = arrayFromConstructorAndList($Array, O);
    return sort(A, compareFn);
  }
});
addToUnscopables("toSorted");
